var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmap-map',{ref:"gmap",staticStyle:{"width":"100%"},attrs:{"id":"googleMap","center":_vm.getCenter,"zoom":_vm.zoomMap}},[_c('gmap-circle',{attrs:{"center":_vm.getCenter,"radius":_vm.getRadius,"options":{
      fillColor: '#009640', 
      fillOpacity: 0.1, 
      strokeColor: '#009640',
      strokeOpacity: 0.1
    }}}),_c('MarkerUser',{attrs:{"locationUser":_vm.getLocationUser,"infoOptions":_vm.infoOptions}}),_c('MarkerPoints',{attrs:{"infoOptions":_vm.infoOptions},on:{"onGenerateRoute":_vm.generateRoute}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }